import React from 'react';

const JurisdictionsDisclaimers = () => (
	<div className="container main">
		<h2>免責事項</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>カナダ</h4>
				<p>
					カナダの消費者製品リコール通知の対象には、カナダ消費者製品安全法（CCPSA：Canada Consumer Product Safety Act）で「家庭での使用、娯楽、スポー
					ツでの使用を含む、非商業目的で個人が使うために取得すると合理的に予想される製品
					で、そのコンポーネント、部品、または付属品、およびその包装も含む」と定義される消費者製品が含まれます。
				</p>
				<p>
					また化粧品も含まれます。
					「化粧品」という用語は、食品医薬品局（FDA）の下で「肌、髪および歯の洗浄、改善または修正に使用するために製造、販売、
					または提示されたあらゆる物質または物質の混合物であり、デオドラント、香水を含む」と定義されています。　
				</p>
				<p>カナダの消費者製品および化粧品のリコール通知対象外となるものには以下が含まれます：</p>
				<ul>
					<li>爆発物法（Explosives Act）のセクション2の意味における爆発物。</li>
					<li>食品医薬品法（Food and Drugs Act）のセクション2の意味におけるデバイス。</li>
					<li>食品医薬品法（Food and Drugs Act）のセクション2の意味における医薬品。</li>
					<li>病害虫管理製品法（Pest Control Products Act）のサブセクション2(1)の意味における病害虫管理製品。</li>
					<li>乗用車安全対策法（Motor Vehicle Safety Act）のセクション2の意味における車両および車両の一部となる部品で、初めての小売購入者に販売される前に組み立てまたは改変が行われたもの。かかる部品を取替または改変する車両の部品も含みます。</li>
					<li>飼料法（Feeds Act）のセクション2の意味における飼料。</li>
					<li>肥料法（Fertilizers Act）のセクション2の意味における肥料。</li>
					<li>2001年カナダ海運法（Canada Shipping Act, 2001）のセクション2の意味における船舶</li>
					<li>刑法（Criminal Code）のセクション2の意味における火器。</li>
					<li>刑法（Criminal Code）のサブセクション84(1)の意味における弾薬。</li>
					<li>刑法（Criminal Code）のサブセクション84(1)の意味におけるカートリッジマガジン。</li>
					<li>刑法（Criminal Code）のサブセクション84(1)の意味におけるクロスボウ。</li>
					<li>刑法（Criminal Code）のサブセクション84(1)で禁止デバイスとして定義されているパラグラフ(a)から(d)までの意味における禁止デバイス。</li>
					<li>植物保護法（Plant Protection Act）のセクション3の意味における植物、ただしトウアズキ（学名abrus precatorius）は除く。</li>
					<li>種子法（Seeds Act）のセクション2の意味における種子、ただしトウアズキ（学名abrus precatorius）は除く。</li>
					<li>規制薬物・物質法（Controlled Drugs and Substances Act）のサブセクション2(1)の意味における規制物質</li>
					<li>航空法（Aeronautics Act）のサブセクション3(1)の意味における航空製品。</li>
					<li>動物衛生法（Health of Animals Act）のサブセクション2(1)の意味における動物。</li>
				</ul>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>欧州委員会</h4>
				<p>Safety Gate / RAPEXの警告でリスクが明記されていない場合、リスクは消費者の健康と安全に対するリスクを指します。</p>
				<p>2010年以降、警告には、専門的な非食品製品や、セキュリティリスクや環境へのリスクなど、他のリスクをもたらす非食品製品に対して講じられた対策も含まれています。</p>
				<p>2019年からは、これまで各国当局間での情報提供のみを目的として回覧されていた警告も、各国当局が必要と判断した場合、ウェブサイトで公開しています。</p>
				<p>このリストに表示される独自のブランド、デザイン、およびロゴは、経済事業者が知的財産権を侵害し、正当な所有者の認識および/または許可なしに使用されている可能性があります。</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>日本</h4>
				<p>日本のリコール通知の対象は、家電、生活雑貨、文具、エンターテインメント製品その他の消費者製品を含みます。食品や車両、医薬品（化粧品を含む）は除きます。</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>米国</h4>
				<p>
					消費者製品安全委員会はコーヒーメーカーから玩具、芝刈り機、花火まで
					多くの種類の消費者製品に対して管轄権を有しますが、一部の消費者製品は他の連邦機関の管轄です。
					他の機関が管轄する製品のリストはこちらをご覧ください：
					<a href="https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/" target="_blank">https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/</a>.
				</p>
			</div>
		</div>
		<hr/>
	</div>
);

export default JurisdictionsDisclaimers ;



// WEBPACK FOOTER //
// ./src/views/static/ja/jurisdictions-disclaimers.js